import { RouteModel } from "../../models";

export function mockRouteModel({
    id = "route-1234",
    type = "route",
    locale = "en",
    content = mockRouteModelContent()
}: Partial<RouteModel> = {}): RouteModel {
    return {
        id,
        type,
        locale,
        content
    };
}

export type RouteModelContent = RouteModel["content"];

export function mockRouteModelContent({
    path = "/foo/bar",
    ...optionals
}: Partial<RouteModelContent> = {}): RouteModelContent {
    return {
        path,
        ...optionals
    };
}
